import React from 'react';
import * as S from './styles';

const Radio = ({
  name,
  id,
  helper,
  warning,
  label,
  onChange,
  className,
  tabIndex,
  disabled,
  children,
  value,
  required,
  defaultChecked,
}: RadioProps) => {
  const labelText = children || label;

  return (
    <S.Radio className={className} disabled={disabled}>
      <S.Label htmlFor={id}>
        <S.Input
          defaultChecked={defaultChecked}
          required={required}
          id={id}
          name={name}
          type="radio"
          onChange={onChange}
          disabled={disabled}
          tabIndex={tabIndex}
          value={value}
        />
        <S.LabelText>
          <span>{labelText}</span>
          {helper && <S.Helper warning={warning}>{helper}</S.Helper>}
        </S.LabelText>
      </S.Label>
    </S.Radio>
  );
};

type RadioProps = {
  name: string;
  id: string;
  label?: string;
  helper?: string;
  warning?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  tabIndex?: number;
  disabled?: boolean;
  children?: React.ReactNode;
  value?: number | string;
  required?: boolean;
  defaultChecked?: boolean;
};

Radio.defaultProps = {
  label: null,
  helper: null,
  warning: false,
  onChange: () => {},
  className: null,
  tabIndex: '0',
  disabled: false,
  children: null,
  value: '',
  required: false,
  defaultChecked: false,
};

export default Radio;
